<template>
  <!-- 审核功能 -->
  <div>
    <BaseDialog title="审核" @handleShow="(val) => { checkModal = val }" :isshow="checkModal" width="500px" height="auto">
      <div class="addform" style="margin-top:10px;">
        <el-form :rules="rulesForm" :model="ruleFormCheck" ref="ruleFormCheckRef" label-width="120px">
          <el-row>
            <el-col :span="23">
              <el-form-item label="审核状态：" prop="check_status">
                <el-select v-model="ruleFormCheck.check_status">
                  <el-option v-for="item in checkStatusList" :key="item.id" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="备注：" prop="check_refuse_reason" :rules="[
              {
                required: isMenu,
                message: '驳回请添加审核意见',
                trigger: 'blur',
              },
            ]">
                <el-input type="textarea" v-model="ruleFormCheck.check_refuse_reason" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right">
        <el-button @click="cacheCheckYao">取消</el-button>
        <el-button type="primary" @click="handleCheck()">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script setup>
  import {
    reactive,
    ref,
    onMounted,
    defineExpose,
    defineEmits,
    nextTick,
    watch
  } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage } from 'element-plus'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  const ruleFormCheck = ref({})
  const checkModal = ref(false)
  const dictCatalogType = ref('')
  const checkInfo = ref('')
  const checkStatusList = ref([{
    name: '通过',
    code: 2
  }, {
    name: '驳回',
    code: 3
  }])
  const rulesForm = reactive({
    'check_status': [{ required: true, trigger: 'blur', message: '请选择审核状态' }],
    "check_refuse_reason": [{ trigger: 'blur', required: isMenu, message: '驳回请添加审核意见' }],
  })
  const isMenu = ref(false)
  const types = ref('')
  watch(() => ruleFormCheck.value.check_status, (newVal, oldVal) => {
    setTimeout(() => {
      if (newVal == 3) {
        isMenu.value = true
      } else {
        isMenu.value = false
      }
    }, 500);
  })
  onMounted(() => {

  })
  const ruleFormCheckRef = ref(null)
  const initData = (id, info, type) => {
    checkModal.value = true
    checkInfo.value = info
    dictCatalogType.value = id
    types.value = type
    ruleFormCheckRef.value.clearValidate()
  }
  const cacheCheckYao = () => {
    checkModal.value = false
    checkInfo.value = ''
    for (const key in ruleFormCheck.value) {
      ruleFormCheck.value[key] = ''
    }
  }
  const em = defineEmits(['refreshDataList'])
  const handleCheck = async () => {
    let data = {}
    let url = ''
    if (types.value == 'rk') {
      data = {
        dict_catalog_type: dictCatalogType.value,
        order_id: checkInfo.value.id,
        ...ruleFormCheck.value
      }
      url = '/api/storeEnterRecord/checkOrder'

    } else if (types.value == 'pd') {
      data = {
        dict_catalog_type: dictCatalogType.value,
        check_order_id: checkInfo.value.id,
        ...ruleFormCheck.value
      }
      url = '/api/storeDrugCheck/checkOrder'
    }
    ruleFormCheckRef.value.validate(async (valid) => {
      if (valid) {
        let res = await service.post(url, data)
        if (res.code == 0) {
          ElMessage.success('审核成功')
          cacheCheckYao()
          em('refreshDataList')
        }
      }
    })
  }


  defineExpose({
    initData,
    cacheCheckYao,
    handleCheck
  })
</script>

<style scoped lang="scss">
  .consumables-search {
    margin-top: 16px;

    .el-form-item {
      width: 95%;
    }
  }
</style>